import React, { useEffect } from 'react';
import { Heading } from '../../../components';
import { FormattedMessage, injectIntl } from 'react-intl';
import css from '../../CheckoutPage/StripePaymentForm/StripePaymentForm.module.css';

const AnzPaymentForm = ({ showComponent }) => {
  useEffect(() => {
    // initializeAnzElement();
  }, []);

  return (
    <div style={{ display: showComponent ? 'block' : 'none', marginBlockStart: '20px' }}>
      <Heading as="h3" rootClassName={css.heading}>
        <FormattedMessage id="StripePaymentForm.paymentHeading" />
      </Heading>
      <div className={css.anzWrapper} id="div-hosted-tokenization"></div>
    </div>
  );
};

export default injectIntl(AnzPaymentForm);
